module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Organisations\n                    "), _c('a', {
    attrs: {
      "href": '#' + _vm.oBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.oBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.oBody
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('datatable', {
    ref: "organisation_datatable",
    attrs: {
      "id": _vm.datatable_id,
      "dtOptions": _vm.organisation_options,
      "dtHeaders": _vm.organisation_headers
    }
  })], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e5a60298"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/internal/organisations/organisations_dashboard.vue
// module id = 1061
// module chunks = 0